export default "__VITE_ASSET__CZmYiZg9__"